import React, { Component } from "react";
import { Tooltip, withStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { connect } from "react-redux";
import { InfoOutlined } from "@material-ui/icons";

class FlagNotification extends Component {
  render() {
    const { classes, message, icon, color, textColor, tooltipTitle } =
      this.props;
    let iconComponent = <InfoOutlined />;
    if (icon === "info" && tooltipTitle) {
      iconComponent = (
        <Tooltip title={tooltipTitle} placement="bottom-start">
          <InfoOutlined fontSize="small" />
        </Tooltip>
      );
    }
    return (
      <Alert
        variant="filled"
        severity={icon}
        className={classes.notificationBar}
        style={{ backgroundColor: color, color: textColor }}
        icon={tooltipTitle && iconComponent}
      >
        {message}
      </Alert>
    );
  }
}

const styles = (theme) => ({
  notificationBar: {
    justifyContent: "center",
    borderRadius: "0px",
    fontSize: window.innerWidth < 767 ? "12px" : "15px",
    display: "flex",
    alignItems: "center",
    zIndex: 10000,
    padding: "7px",
    height: window.innerWidth < 767 ? "2.5%" : "2%",
    "& .MuiAlert-icon": {
      fontSize: "20px",
      marginRight: "6px",
      position: "relative",
      bottom: "1px",
    },
  },
});

const connectFlagNotification = connect((state) => ({
  partner: state.partner.partner,
}))(FlagNotification);

export default withStyles(styles)(connectFlagNotification);
